<template>
  <div class="target-wrapper white elevation-1 mb-4">
    <!-- F1 Events Dropdown -->
    <div class="d-flex">
      <v-select
        v-model="selectedEvent"
        :items="selectItems"
        item-title="text"
        item-value="value"
        label="Please Choose Event"
        @change="onEventChange"
        class="ma-1"
      ></v-select>
    </div>

    <!-- Added margin bottom for spacing between dropdown and bar -->
    <div class="mb-2">
      <!-- Capacity Bar -->
      <div class="target-bar-container">
        <div 
          class="target-bar" 
          :style="{ width: percentageFilled + '%' }"
          :class="barColorClass"
        ></div>
      </div>
    </div>

    <div class="target-info">
      <span>{{ currentEventData.soldTickets }} / {{ currentEventData.totalCapacity }} Tickets</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TargetBar',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'reportingData',
      'season',
      'lastSeasonReportingData',
      'eventGroupsForCurrentSeason',
      'selectedF1Event',
      'eventTargets'
    ]),
    selectedEvent: {
      get() {
        return this.selectedF1Event
      },
      set(value) {
        this.$store.commit('setSelectedF1Event', value)
      }
    },
    selectItems() {
      return [
        { value: 'all', text: 'All Events' },
        ...this.eventGroupsForCurrentSeason.map(event => ({
          value: event.id.toString(),
          text: event.name
        }))
      ]
    },
    currentEventData() {
      if (this.selectedEvent === 'all') {
        return this.totalEventData
      }
      
      const eventId = parseInt(this.selectedEvent)
      const eventIdStr = String(eventId) // Convert to string for consistent comparison
      
      // console.log(`Looking for event data with ID: ${eventId} (${typeof eventId}), as string: "${eventIdStr}"`);
      // console.log('Available event targets:', this.eventTargets.map(t => ({ id: t.FK_EventGroup, type: typeof t.FK_EventGroup })));
      
      const eventData = this.reportingData.filter(item => 
        item.event_group_id === eventId && 
        this.isMultiDayTicket(item)
      )
      
      if (eventData.length > 0) {
        const soldTickets = eventData.reduce((sum, item) => sum + (parseInt(item.Menge) || 0), 0)
        // Get target capacity from the store
        const targetData = this.eventTargets.find(target => String(target.FK_EventGroup) === eventIdStr)
        
        // if (targetData) {
        //   console.log(`Found target data for event ${eventIdStr}:`, targetData);
        // } else {
        //   console.warn(`No target data found for event ${eventIdStr}`);
        // }
        
        const totalCapacity = targetData ? targetData.TargetSales : 1000
        return { soldTickets, totalCapacity }
      }
      
      return { soldTickets: 0, totalCapacity: 100 }
    },
    totalEventData() {
      const relevantData = this.reportingData.filter(item => 
        this.isMultiDayTicket(item)
      )
      
      const soldTickets = relevantData.reduce((sum, item) => sum + (parseInt(item.Menge) || 0), 0)
      // Calculate total capacity from all event targets in the store
      const totalCapacity = this.eventTargets.length > 0 
        ? this.eventTargets.reduce((sum, target) => sum + (parseInt(target.TargetSales) || 0), 0)
        : 5000
      return { soldTickets, totalCapacity }
    },
    percentageFilled() {
      const { soldTickets, totalCapacity } = this.currentEventData
      return Math.min((soldTickets / totalCapacity) * 100, 100)
    },
    barColorClass() {
      const percentage = (this.currentEventData.soldTickets / this.currentEventData.totalCapacity) * 100
      if (percentage < 30) return 'bar-low'
      if (percentage < 70) return 'bar-medium'
      return 'bar-high'
    }
  },
  methods: {
    ...mapActions([
      'getEventTargets',
      'loadContractualContingentByEvent'
    ]),
    onEventChange() {
      this.$store.commit('setSelectedF1Event', this.selectedEvent);
    },
    isMultiDayTicket(item) {
      if (!item || typeof item !== 'object') return false;
      return item.FK_ArticleType === 1 || item.FK_ArticleType === 2;
    }
  },
  created() {
    // Fetch event targets from the store
    this.getEventTargets()
      .then(result => {
        // console.log('Event Targets API Response:', result);
        if (Array.isArray(result)) {
          result.forEach((item, index) => {
            // console.log(`Event Target ${index}:`, item);
          });
        }
        // console.log('Event Targets from store:', this.eventTargets);
      })
      .catch(error => {
        // console.error('Error fetching event targets:', error);
      });
    
    // Load and log contractual contingent by event
    this.loadContractualContingentByEvent()
      .then(result => {
        // console.log('TargetBar - ContractualContingentByEvent result:', result);
      })
      .catch(error => {
        // console.error('TargetBar - Error loading contractual contingent by event:', error);
      });
  }
}
</script>

<style scoped>
.target-wrapper {
  width: 100%;
  padding: 1rem;
  border-radius: 4px;
}

.target-info {
  /* margin-bottom: 0.5rem; */
  font-size: 0.9rem;
}

.target-bar-container {
  width: 100%;
  height: 24px;
  background-color: #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
}

.target-bar {
  height: 100%;
  transition: width 0.3s ease, background-color 0.3s ease;
}

.bar-low {
  background-color: #f56565; /* Rot */
}

.bar-medium {
  background-color: #ecc94b; /* Gelb */
}

.bar-high {
  background-color: #48bb78; /* Grün */
}
</style>